import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function SettingsSidebar() {
    return <>
        <section className="faqsSection bg-registers p-4 ">
                    <>
                      <h4 className="myaccnt-hd">My Account</h4>
                      <div className="vertmenu">
                        <ul>
                          <li>
                            <Link to="/dashboard">
                              <i className="fa-solid fa-angles-right" /> Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link to="/my-profile">
                              <i className="fa-solid fa-angles-right" /> My Profile
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile-photo-edit">
                              <i className="fa-solid fa-angles-right" /> My Photos
                            </Link>
                          </li>
                          <li>
                            <Link to="/my-profile/partner">
                              <i className="fa-solid fa-angles-right" /> Partner Preference
                            </Link>
                          </li>
                          <li>
                            <Link to="/settings">
                              <i className="fa-solid fa-angles-right" /> Settings
                            </Link>
                          </li>
                          <li>
                            <Link to="/shortlist">
                              <i className="fa-solid fa-angles-right" /> Shortlist
                            </Link>
                          </li>
                          <li>
                            <Link to="/photo-request">
                              <i className="fa-solid fa-angles-right" /> Photo Request
                            </Link>
                          </li>
                          <li>
                            <Link to="/dob-request">
                              <i className="fa-solid fa-angles-right" /> DOB Request
                            </Link>
                          </li>
                          <li>
                            <Link to="#">
                              <i className="fa-solid fa-angles-right" /> Notification
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </>
                    </section>
    </>
}
export default SettingsSidebar;